import * as React from 'react';

export const ConsoleReadyToRun: React.StatelessComponent<{}> = () => (
  <div className={'console-component--ready-to-run console-component--line-system'}>
    Ready to Run Code
  </div>
);
